// extracted by mini-css-extract-plugin
export default {"modalOverlay":"cQ-z","modalContent":"dQ-z","header":"eQ-z","close":"fQ-z"};